import './application_page.css';

/*
 * Description: Application Page Web Component
 * Purpose: A reusable application page component specifically designed for the main div of the application
 * Author: Nuvemx
 * Created: 2026
 * 
 * Features:
 * - 
 * 
 * Usage:
 * <application-page id="xxxxxxxxxx"></application-page>
 * 
 * Attributes:
 * - id: String - The id of the html element
 * 
  */

class application_page extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) {
            return;
        }
        const wrapper = document.createElement('div');
        wrapper.id = this.getAttribute('pageId');
        wrapper.className = 'body-content';
        wrapper.style.display = this.getAttribute('display');
        while (this.firstChild) wrapper.appendChild(this.firstChild);
        this.appendChild(wrapper);
        this.dataset.rendered = "true";
    }
}

export { application_page };